import { isInsideCode, type Mention, type MentionTarget, mentionMarkup, replaceMentions } from "@serophin/shared";
import { escapeHtml } from "../markdown";

export const DEFAULT_MENTION_CHIP_CLASSES =
  "inline-flex items-center rounded px-1 py-0.5 bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 text-[0.9em] font-medium no-underline";

const chipHtml = (target: MentionTarget, chipClass: string): string => {
  const tag = target.href ? "a" : "span";
  const href = target.href ? ` href="${escapeHtml(target.href)}"` : "";
  const title = target.title ? ` title="${escapeHtml(target.title)}"` : "";
  return `<${tag}${href}${title} class="${chipClass}">@${escapeHtml(target.label)}</${tag}>`;
};

export const linkMentions = (source: string, mentions: MentionTarget[], chipClass: string = DEFAULT_MENTION_CHIP_CLASSES): string => {
  const byId = new Map(mentions.map((target) => [target.id, target]));
  return replaceMentions(source, (mention: Mention, index: number) => {
    if (isInsideCode(source, index + 1)) {
      return mentionMarkup(mention.id, mention.label);
    }
    const target = byId.get(mention.id);
    return target ? chipHtml(target, chipClass) : `@${mention.label}`;
  });
};
